/* @flow */
import API from 'lib/RemindAPI';
import PotentialChatMembers from 'collections/PotentialChatMembers';
import Chats from 'collections/Chats';

export function search(query: string): Promise<PotentialChatMembers> {
  return API.request('/chats/members/search', 'GET', { q: query }).then(members => {
    return PotentialChatMembers.fromJSON(members);
  });
}

export function groupChatsQuery(query: string): Promise<Chats> {
  return API.request('/chats', 'GET', {
    q: query,
    include_messages: false,
    include_memberships: false,
    only_group_chats: true,
  }).then(groupChats => {
    return Chats.fromJSON(groupChats);
  });
}
